import { getIntegrationStatus } from 'lib/api/express/integrations';
import CustomAlert from 'lib/designSystem/Alert';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import BankAccounts from '../../BusinessProfile/Profile/components/BankAccounts';
import SettingsCertificate from './components/Certificate';
import CompanyInformation from './components/CompanyInformation';
import SettingsCompliance from './components/Compliance';
import Contracts from './components/Contracts';

const baseTabs = [
  {
    index: 1,
    label: 'Información de la empresa',
    component: <CompanyInformation />,
  },
  {
    index: 2,
    label: 'Certificados',
    component: <SettingsCertificate />,
  },
  {
    index: 3,
    label: 'Compliance',
    component: <SettingsCompliance />,
  },
  {
    id: 4,
    label: 'Banco',
    component: <BankAccounts pruffConnect />,
    path: 'bankAccounts',
  },
];

const Settings = () => {
  const dispatch = useDispatch();
  const domain = window.location.hostname;
  const secretId = domain.split('.')[0];
  const [openAlertSuccess, setOpenAlertSuccess] = useState('');
  const [openAlertFailed, setOpenAlertFailed] = useState('');
  const [tabs, setTabs] = useState(baseTabs);
  const { data } = getIntegrationStatus(
    dispatch,
    secretId,
    'digital-signature',
  );

  const hasDigitalSignature = data?.status;

  const setUpTabs = () => {
    if (hasDigitalSignature) {
      setTabs([
        ...baseTabs,
        {
          id: 5,
          label: 'Contratos',
          component: <Contracts />,
          path: 'contracts',
        },
      ]);
    } else {
      setTabs([...baseTabs]);
    }
  };

  useEffect(() => {
    setUpTabs();
  }, [hasDigitalSignature]);

  return (
    <div>
      <EnhancedTab title="Configuración" startValue={0} tabs={tabs} />
      <CustomAlert
        open={openAlertSuccess.length}
        title="Éxito"
        text={openAlertSuccess}
        setOpen={setOpenAlertSuccess}
      />
      <CustomAlert
        open={openAlertFailed.length}
        title="Error"
        text={openAlertFailed}
        setOpen={setOpenAlertFailed}
      />
    </div>
  );
};

export default Settings;
